import { TRACK_HELP_CHAT_EVENT } from "./constants";

export const trackHelpChatEvent = (
  key: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any,
  skipUpdate = false,
) => ({
  payload: { key, value, skipUpdate },
  type: TRACK_HELP_CHAT_EVENT,
});
